// Non-React shared flags: while a shelf drag-reorder or a written-thought
// composition is in progress, the app-level swipe-between-sections gesture
// must stand down completely. Plain mutable objects (not React state) by
// design — they're read inside imperative touch handlers, not rendered.

export const shelfDragFlag = { active: false, justDragged: false };
export const textWritingFlag = { active: false };
